import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "a11y-live-regions",
  "aria-hidden": "false"
}

import { onMounted, onUnmounted, ref } from "vue";
import {
  registerA11yLiveRegions,
  unregisterA11yLiveRegions,
} from "@/utils/a11yLiveRegion";


export default /*#__PURE__*/_defineComponent({
  __name: 'A11yLiveRegion',
  setup(__props) {

const politeRef = ref<HTMLElement | null>(null);
const assertiveRef = ref<HTMLElement | null>(null);

onMounted(() => {
  if (politeRef.value) {
    registerA11yLiveRegions(politeRef.value, assertiveRef.value);
  }
});

onUnmounted(() => {
  unregisterA11yLiveRegions();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "politeRef",
      ref: politeRef,
      id: "a11y-live-polite",
      role: "status",
      "aria-live": "polite",
      "aria-atomic": "true",
      class: "visually-hidden"
    }, null, 512),
    _createElementVNode("div", {
      ref_key: "assertiveRef",
      ref: assertiveRef,
      id: "a11y-live-assertive",
      role: "alert",
      "aria-live": "assertive",
      "aria-atomic": "true",
      class: "visually-hidden"
    }, null, 512)
  ]))
}
}

})